import CustomInput from "../CustomInput";

const ELEVEN_NUMBERS = /^[0-9]{0,11}$/;

// ЄДРПОУ
class RegistrationNumberInput extends CustomInput {
  transform = value => this.clearSpaces(value);
  
  validate = value => ELEVEN_NUMBERS.test(value);
}

export default RegistrationNumberInput;
// import React from "react";
// import MaskedInput from "react-maskedinput";
//
// export default function MfoInput(props) {
//   const mask = "1".repeat(11);
//
//   return (
//     <MaskedInput mask={mask} placeholder="" placeholderChar=" " {...props} />
//   );
// }
